import { RootState } from 'src/store/store';
import { useSelector } from 'react-redux';

import useLoginState from '@hooks/useLoginState';
import { getLabelFallback, isMobile } from '@utils/utils';
import NewPrescriptionForm from '../prescription-form/NewPrescriptionForm';
import InfoIconSmall from '@images/svg-icons/infoIconSmall.svg';
import clsx from 'clsx';

interface Props {
    showNoPrescriptionsAlert: boolean;
}

const AddNewPrescription = ({ showNoPrescriptionsAlert }: Props) => {
    const currentProduct = useSelector((state: RootState) => state.contacts.currentProduct);
    const { isLoggedIn, login } = useLoginState();

    const loginErrorHandler = () => {
        console.error('Could not log in'); // TODO: show error?
    };

    return (
        <div className="contact-lens-prescription logged-select-prescription">
            <div
                className={clsx('contact-lens-prescription-title', {
                    'no-underline': isLoggedIn === 'LOGGED' && !showNoPrescriptionsAlert,
                })}
            >
                {isLoggedIn === 'LOGGED' ? (
                    <>
                        {showNoPrescriptionsAlert ? (
                            <>
                                <div className="add-new-prescription-title">
                                    ADD NEW PRESCRIPTION
                                </div>
                                <span className="subtitle">
                                    {getLabelFallback(
                                        'CONTACT_LENSES_PRESCRIPTION_INFO_LOGGED_NO_PRESC_PT1'
                                    )}
                                    {isMobile ? <br /> : ' '}
                                    {getLabelFallback(
                                        'CONTACT_LENSES_PRESCRIPTION_INFO_LOGGED_NO_PRESC_PT2'
                                    )}
                                </span>
                            </>
                        ) : (
                            <>{getLabelFallback('CONTACT_LENSES_PRESCRIPTION_INFO_LOGGED')}</>
                        )}
                    </>
                ) : (
                    <>
                        {getLabelFallback('CONTACT_LENSES_PRESCRIPTION_INFO_GUEST_PT1')}{' '}
                        <span>
                            <button
                                className="login-text-button"
                                onClick={() => login(loginErrorHandler)}
                            >
                                sign in
                            </button>
                        </span>{' '}
                        {getLabelFallback('CONTACT_LENSES_PRESCRIPTION_INFO_GUEST_PT2')}
                    </>
                )}
            </div>

            {!!currentProduct && <NewPrescriptionForm />}
        </div>
    );
};

export default AddNewPrescription;
